<template>
    <UPageGrid>
        <slot/>
    </UPageGrid>
</template>